import type {
	Components,
} from '@mui/material'

export const materialUIPaginationTheme: {
	components: Components
} = {
	components: {
		MuiPagination: {
			defaultProps: {
			},
			styleOverrides: {
			},
			variants: [
			],
		},
	},
}
